<mat-toolbar>
    <button mat-icon-button (click)="back()">
        <mat-icon>navigate_before</mat-icon>
    </button>
    <span class="ml-normal">GAT Terms of Use</span>
</mat-toolbar>

<div>
    todo
</div>